import React, { useRef, useState } from "react";
import {
  Avatar,
  Checkbox,
  // Divider, Card,
  Modal,
  notification,
  Popconfirm,
  Select,
  Skeleton,
  Space,
} from "antd";
import moment from "moment/moment";
import { CustomButton } from "../../../../../components";
import "./styles.scss";
// import { TIMEZONE_LIST } from "../../../../../enum";
import { convertToLocalTime } from "../../../../../utils/format";
import NoItemsMessageCard from "../../../../../components/NoItemsMessageCard";
import iconDown from "images/icon-linkedin.svg";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import httpClient from "../../../../../api/module/httpClient";
import { searchUser } from "api";
const { Option } = Select;
// import MoreInfo from "./MoreInfo";
// import linkedInIcon from "../../../../../images/icon-linkedin.svg";
// import IconMail from "../../../../../images/icon-mail-outline.svg";
// import PopupSpeakerSummit from "../../../../CertificateDashboard/PopupInstructor";

const MAX_NUM_APPLICANTS = 10;

export default function CallForFacultyClassItem({ item, userProfile }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [usersToBeAdded, setUsersToBeAdded] = useState(null);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [searchedUsers, setSearchedUsers] = useState([]);

  const timezone = userProfile?.timezone;

  const { data: facultyList, isLoading } = useQuery({
    queryKey: ["CLASS_FACULITY_LIST", item.id],
    queryFn: async () => {
      const { data } = await httpClient.get(
        `private/certificate-class/${item.id}/faculty`
      );

      return data;
    },
    enabled: !!item?.id,
  });

  const queryClient = useQueryClient();

  const joinMutation = useMutation({
    mutationFn: async () => {
      const certificateClassId = item.id;
      return await httpClient.post(
        `private/certificate-class/${certificateClassId}/faculty`,
        { allowCoFaculty: checked }
      );
    },
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries(["CLASS_FACULITY_LIST", item.id]);

      if (data.type === "EXCEEDED") {
        notification.info({
          message: "Class has exceeded the number of applicants",
        });

        return;
      }

      setIsModalOpen(false);
      setChecked(false);

      notification.success({
        message: "Success",
      });
    },
    onError: () => {
      notification.error({
        message: "Something went wrong.",
      });
    },
  });

  const updateStatusMutation = useMutation({
    mutationFn: async ({ status }) => {
      const certificateClassId = item.id;
      await httpClient.patch(
        `private/certificate-class/${certificateClassId}/faculty`,
        { status }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["CLASS_FACULITY_LIST", item.id]);
      notification.success({
        message: "Success",
      });
    },
    onError: () => {
      notification.error({
        message: "Something went wrong.",
      });
    },
  });

  const isFaculty = (facultyList || []).find(
    (faculty) => faculty.UserId === userProfile?.id
  );

  const getButtonText = () => {
    if ((facultyList ?? []).length === 10) return "FULL";
    if (isFaculty) return "WITHDRAW";
    return "APPLY HERE";
  };

  const actionMutation = useMutation({
    mutationFn: async ({ userId, type }) => {
      if (!type) throw new Error("No type chosen");

      return httpClient.post(
        `private/certificate-class/${item.id}/faculty/${type}`,
        { userId }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["CLASS_FACULITY_LIST", item.id]);
      queryClient.invalidateQueries(["MY_FACULTY_DASHBOARD", userProfile?.id]);
      queryClient.invalidateQueries([
        "MY_FACULTY_DASHBOARD_PAST",
        userProfile?.id,
      ]);
      notification.success({
        message: "Success",
      });
    },
  });

  let startDate = convertToLocalTime(item.startDate, item.timezone);
  let startTime = convertToLocalTime(item.startTime, item.timezone);
  let endTime = convertToLocalTime(item.endTime, item.timezone);

  const searchUserMutation = useMutation({
    mutationFn: async ({ search }) => {
      const { data } = await searchUser({ search });

      return data;
    },
    onSuccess: (data) => {
      setSearchedUsers(data.users);
    },
  });

  const addFacultyMutation = useMutation({
    mutationFn: async ({ CourseClassId }) => {
      const { data } = await httpClient.post(
        `private/certificate-class/${CourseClassId}/admin-add-faculty`,
        { userId: usersToBeAdded }
      );

      return data;
    },
    onSettled: () => {
      setUsersToBeAdded(null);
      setIsAddUserModalOpen(false);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["CLASS_FACULITY_LIST", item.id]);
      notification.success({
        message: "Success",
      });
    },
    onError: () => {
      notification.error({
        message: "Something went wrong.",
      });
    },
  });

  const isAdmin = [
    "enrique@hackinghr.io",
    "danielle@hackinghr.io",
    "lourencelinao13@gmail.com",
  ].includes(userProfile?.email);

  return (
    <div className="call-for-faculty-class-item">
      <Modal
        visible={isAddUserModalOpen}
        title="Add User"
        onCancel={() => {
          setIsAddUserModalOpen(false);
          setUsersToBeAdded(null);
        }}
        onOk={() => {
          // handleAddUser();
          addFacultyMutation.mutate({ CourseClassId: item.id });
        }}
        okText="Enroll"
      >
        <Select
          showSearch={true}
          style={{ width: "100%" }}
          // mode="multiple"
          onKeyUp={(e) => {
            searchUserMutation.mutate({ search: e.target.value });
          }}
          onChange={(e) => {
            setUsersToBeAdded(e);
          }}
          value={usersToBeAdded}
          optionFilterProp="children"
        >
          {(searchedUsers ?? []).map((users) => {
            return (
              <Option key={users.id} value={users.id}>
                {`${users.firstName} / ${users.email}`}
              </Option>
            );
          })}
        </Select>
      </Modal>
      <Space direction="vertical" style={{ width: "100%" }}>
        <h3>{item.title}</h3>
        <div
          dangerouslySetInnerHTML={{ __html: item?.descriptionForCertificate }}
        ></div>
        <h5>Class Date: {`${(startDate || moment())?.format("LL")}`}</h5>
        <h5>
          Class Start Time: {(startTime || moment())?.format("HH:mm a")}{" "}
          {moment.tz.guess()}
        </h5>
        <h5>
          Class End Time: {(endTime || moment())?.format("HH:mm a")}{" "}
          {moment.tz.guess()}
        </h5>
        {isAdmin && (
          <CustomButton
            text="Add User"
            onClick={() => setIsAddUserModalOpen(true)}
            size="small"
          />
        )}

        <Modal
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
            setChecked(false);
          }}
          onOk={() => {
            joinMutation.mutate();
          }}
        >
          {/*<div>This is a modal</div>*/}
          <div>
            <Checkbox
              onChange={(e) => setChecked(e.target.checked)}
              checked={checked}
            >
              Are you open to having a co-faculty (co-facilitator) prepare and
              deliver the class with you?
            </Checkbox>
          </div>
        </Modal>

        {!isLoading && (
          <Popconfirm
            title={"Are you sure you want to withdraw?"}
            disabled={!isFaculty}
            onConfirm={() => {
              if (isFaculty) {
                updateStatusMutation.mutate({ status: "withdrawn" });
              }
            }}
          >
            {!isFaculty && (
              <CustomButton
                text={getButtonText()}
                type={isFaculty ? "third" : "primary"}
                size="small"
                onClick={() => {
                  if (!isFaculty) setIsModalOpen(true);
                }}
                disabled={(facultyList?.length ?? []) === MAX_NUM_APPLICANTS}
                loading={joinMutation.isLoading}
              />
            )}
          </Popconfirm>
        )}

        <button
          className="expand-button"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? "Less information" : "More information"}
        </button>

        <div
          className={`expandable-content ${isExpanded ? "expanded" : ""}`}
          ref={contentRef}
          style={{
            maxHeight: isExpanded
              ? `${contentRef.current?.scrollHeight}px`
              : "0",
          }}
        >
          {isLoading && <Skeleton />}

          {(facultyList || []).length === 0 && (
            <NoItemsMessageCard message="There are no faculty members in this class." />
          )}

          <div className="faculty-list">
            {(facultyList || [])
              .filter((faculty) => faculty.status === "confirmed")
              .map((faculty) => {
                let caseLink =
                  faculty.User?.personalLinks?.linkedin?.substring(0, 7) !==
                    "http://" &&
                  faculty.User?.personalLinks?.linkedin?.substring(0, 8) !==
                    "https://"
                    ? `https://${faculty.User?.personalLinks?.linkedin}`
                    : faculty.User?.personalLinks?.linkedin;

                if (caseLink?.substring(0, 14) === "http://http://") {
                  caseLink = caseLink.substring(7, caseLink.length);
                }

                if (caseLink?.substring(0, 16) === "https://https://") {
                  caseLink = caseLink.substring(8, caseLink.length);
                }

                return (
                  <div key={faculty.User.id} className="faculty-item">
                    <div className="faculty-header">
                      <Avatar src={faculty.User?.img || faculty.img} />
                      <div>
                        <h3>
                          {faculty.User.firstName} {faculty.User.lastName}
                          {faculty.status === "pending" && (
                            <span>- PENDING</span>
                          )}
                          {faculty.allowCoFaculty &&
                            userProfile.role === "admin" && (
                              <span>- Allows Co-faculty</span>
                            )}
                        </h3>
                        <h5>{faculty.User.titleProfessions}</h5>
                        <a
                          href={caseLink || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className={"module-icon-linkedin"}
                            src={iconDown}
                            alt="linkedin"
                          />
                        </a>
                      </div>
                    </div>

                    {[
                      "enrique@hackinghr.io",
                      "danielle@hackinghr.io",
                      "lourencelinao13@gmail.com",
                    ].includes(userProfile?.email) && (
                      <div className="admin-actions">
                        <Popconfirm
                          title={"Are you sure you want to remove this user?"}
                          onConfirm={() =>
                            actionMutation.mutate({
                              userId: faculty.User.id,
                              type: "remove",
                            })
                          }
                        >
                          <CustomButton
                            text="Remove"
                            type="third"
                            size="small"
                            style={{ width: "100%" }}
                            loading={actionMutation.isLoading}
                          />
                        </Popconfirm>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>

          <div className="faculty-list" style={{ marginTop: "3rem" }}>
            {(facultyList || [])
              .filter((faculty) => faculty.status === "pending")
              .map((faculty) => {
                let caseLink =
                  faculty.User?.personalLinks?.linkedin?.substring(0, 7) !==
                    "http://" &&
                  faculty.User?.personalLinks?.linkedin?.substring(0, 8) !==
                    "https://"
                    ? `https://${faculty.User?.personalLinks?.linkedin}`
                    : faculty.User?.personalLinks?.linkedin;

                if (caseLink?.substring(0, 14) === "http://http://") {
                  caseLink = caseLink.substring(7, caseLink.length);
                }

                if (caseLink?.substring(0, 16) === "https://https://") {
                  caseLink = caseLink.substring(8, caseLink.length);
                }
                return (
                  <div key={faculty.User.id} className="faculty-item">
                    <div className="faculty-header">
                      <Avatar src={faculty.User?.img || faculty.img} />
                      <div>
                        <h3>
                          {faculty.User.firstName} {faculty.User.lastName}
                          {faculty.status === "pending" && (
                            <span>- PENDING</span>
                          )}
                          {faculty.allowCoFaculty &&
                            userProfile.role === "admin" && (
                              <span>- Allows Co-faculty</span>
                            )}
                        </h3>
                        <h5>{faculty.User.titleProfessions}</h5>
                        <a
                          href={caseLink || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className={"module-icon-linkedin"}
                            src={iconDown}
                            alt="linkedin"
                          />
                        </a>
                      </div>
                    </div>

                    {[
                      "enrique@hackinghr.io",
                      "danielle@hackinghr.io",
                      "lourencelinao13@gmail.com",
                    ].includes(userProfile?.email) && (
                      <div className="admin-actions">
                        <div className="pending-actions">
                          <Popconfirm
                            title={
                              "Are you sure you want to approve this user?"
                            }
                            onConfirm={() => {
                              actionMutation.mutate({
                                userId: faculty.User.id,
                                type: "approve",
                              });
                            }}
                          >
                            <CustomButton
                              text="Approve"
                              type="secondary"
                              size="small"
                              loading={actionMutation.isLoading}
                              style={{ width: "150px" }}
                            />
                          </Popconfirm>
                          <Popconfirm
                            title={"Are you sure you want to reject this user?"}
                            onConfirm={() => {
                              actionMutation.mutate({
                                userId: faculty.User.id,
                                type: "reject",
                              });
                            }}
                          >
                            <CustomButton
                              text="Reject"
                              type="third"
                              size="small"
                              loading={actionMutation.isLoading}
                              style={{ width: "150px" }}
                            />
                          </Popconfirm>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </Space>
    </div>
  );
}
